import React, { useCallback, useState } from "react"
import "./checkbox-input.css"
import { useTranslation } from "@nova/use-translation"
import className from "classnames"

type CheckboxInputProps = {
    id: string
    label?: string
    value?: boolean
    classNames?: string
    inputClassNames?: string
    onChange: (value: boolean) => void
    className?: string
    disabled?: boolean
    isSmall?: boolean
    isDark?: boolean
}
export const CheckboxInput = ({
    id,
    value,
    label,
    onChange,
    disabled,
    classNames,
    inputClassNames,
    isSmall,
    isDark,
}: CheckboxInputProps) => {
    const [checked, setChecked] = useState(value)
    const { t } = useTranslation()

    const handleCheckboxClick = useCallback(() => {
        onChange(!checked)
        setChecked(!checked)
    }, [checked, onChange])
    return (
        <div
            className={className(
                "checkbox-input cursor-pointer",
                { "checkbox-input--normal": !isSmall, "checkbox-input--small": isSmall },
                {
                    "checkbox-input--dark": false && isDark,
                } /** TODO: need to come back to this, couldnt get the checkmark color changing to work */,
                { "cursor-not-allowed": disabled },
                classNames
            )}
        >
            <input
                id={id}
                className={inputClassNames}
                onChange={handleCheckboxClick}
                checked={checked}
                type="checkbox"
                data-testid="checkbox-input"
                disabled={disabled}
            />
            {label && (
                <label
                    className={className({ "text-gray-300": disabled })}
                    style={{ cursor: "inherit" }}
                    htmlFor={id}
                >
                    {t(label)}
                </label>
            )}
        </div>
    )
}
